import styled from "styled-components";

export const JIRA_CLOUD_URL =
  "https://cbobraze.atlassian.net/servicedesk/customer/portal/1/group/38/create/115";

export const JiraMigrationBanner = () => (
  <Banner>
    Campaign Builder have moved to{" "}
    <a href={JIRA_CLOUD_URL} target="_blank" rel="noopener noreferrer">
      Jira Cloud
    </a>
  </Banner>
);

const Banner = styled.div`
  width: 100%;
  padding: 0.75rem 1.5rem;
  background: #f3e8ff;
  border: 1px solid #d8b4fe;
  border-radius: 0.5rem;
  color: #581c87;
  font-size: 16px;
  text-align: center;

  a {
    color: #7c3aed;
    font-weight: 600;
    text-decoration: underline;
  }
`;
